import { createSlice } from '@reduxjs/toolkit';
import { Settings, State } from 'types/Store';

const initialState = {
  sidebarCollapsed: false,
};

export const settings = createSlice( {
  name: 'settings',
  initialState,
  reducers: {
    toggleSidebar: ( state: Settings ) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
  },
} );

export const {
  toggleSidebar,
} = settings.actions;

export const selectSidebarCollapsed = ( state: State ) => state.settings.sidebarCollapsed;

export default settings.reducer;
